import { AppRouteProps } from "@bsm/component";
import React from "react";

const StudentImport = React.lazy(() => import("./container/StudentImport"))

export const StudentImportRoute = [
    {
        path: "import",
        roles: ['STUDENT_IMPORT'],
        element: <StudentImport />
    }
] as Array<AppRouteProps>